module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "TOC-Header",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_vm._v("Table of"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass6#_idTextAnchor132"
    }
  }, [_vm._v("Foreword")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass81#_idTextAnchor385"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass81#_idTextAnchor385"
    }
  }, [_vm._v("Preface")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass7#_idTextAnchor134"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass7#_idTextAnchor134"
    }
  }, [_vm._v("Chapter 1—The Plastic Problem")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass8#_idTextAnchor136"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass8#_idTextAnchor136"
    }
  }, [_vm._v("This Is How Plastic Is Made")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass8#_idTextAnchor138"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass8#_idTextAnchor138"
    }
  }, [_vm._v("Microplastic")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass9#_idTextAnchor140"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass9#_idTextAnchor140"
    }
  }, [_vm._v("Garbage Islands")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass11#_idTextAnchor142"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass11#_idTextAnchor142"
    }
  }, [_vm._v("What Are We Doing about It?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass12#_idTextAnchor144"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass12#_idTextAnchor144"
    }
  }, [_vm._v("Chapter 2—Recycling: A Waste-Management Guide")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass13#_idTextAnchor146"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass13#_idTextAnchor146"
    }
  }, [_vm._v("How Is Plastic Recycled?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass13#_idTextAnchor148"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass13#_idTextAnchor148"
    }
  }, [_vm._v("What about Bioplastic?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass13#_idTextAnchor150"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass13#_idTextAnchor150"
    }
  }, [_vm._v("How Is Organic Waste Recycled?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass13#_idTextAnchor152"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass13#_idTextAnchor152"
    }
  }, [_vm._v("How Is Glass Recycled?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass15#_idTextAnchor154"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass15#_idTextAnchor154"
    }
  }, [_vm._v("How Is Paper Recycled?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass17#_idTextAnchor156"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass17#_idTextAnchor156"
    }
  }, [_vm._v("How Is Metal Recycled?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass17#_idTextAnchor158"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass17#_idTextAnchor158"
    }
  }, [_vm._v("What about Return Systems?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass18#_idTextAnchor160"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass18#_idTextAnchor160"
    }
  }, [_vm._v("Chapter 3—Going Green: Working Toward Zero Waste")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass20#_idTextAnchor162"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass20#_idTextAnchor162"
    }
  }, [_vm._v("How I Got Started")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass20#_idTextAnchor164"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass20#_idTextAnchor164"
    }
  }, [_vm._v("A Beginner’s Guide")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor017"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass22#_idTextAnchor166"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass22#_idTextAnchor166"
    }
  }, [_vm._v("You Cannot Buy Your Way Out of the Climate Crisis")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor018"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass22#_idTextAnchor168"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass22#_idTextAnchor168"
    }
  }, [_vm._v("How Do You Avoid Greenwashing?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor019"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass22#_idTextAnchor170"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass22#_idTextAnchor170"
    }
  }, [_vm._v("Tips for avoiding greenwashing")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor020"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass24#_idTextAnchor172"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass24#_idTextAnchor172"
    }
  }, [_vm._v("Chapter 4—The Plastic You Cannot Avoid")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor021"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass25#_idTextAnchor174"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass25#_idTextAnchor174"
    }
  }, [_vm._v("Chapter 5—A Zero-Waste Household")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor022"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass26#_idTextAnchor176"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass26#_idTextAnchor176"
    }
  }, [_vm._v("Homemade Cleaning Supplies")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor023"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass30#_idTextAnchor178"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass30#_idTextAnchor178"
    }
  }, [_vm._v("Dish soap")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor024"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass30#_idTextAnchor180"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass30#_idTextAnchor180"
    }
  }, [_vm._v("Brushes and cloths")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor025"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass32#_idTextAnchor182"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass32#_idTextAnchor182"
    }
  }, [_vm._v("Alternatives to Foil and Film")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor026"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass32#_idTextAnchor184"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass32#_idTextAnchor184"
    }
  }, [_vm._v("Toilet paper")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor027"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass34#_idTextAnchor186"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass34#_idTextAnchor186"
    }
  }, [_vm._v("Recipe for Toilet Tabs")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor028"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass34#_idTextAnchor188"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass34#_idTextAnchor188"
    }
  }, [_vm._v("Laundry")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor029"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass34#_idTextAnchor190"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass34#_idTextAnchor190"
    }
  }, [_vm._v("Compost Guide")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor030"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass34#_idTextAnchor192"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass34#_idTextAnchor192"
    }
  }, [_vm._v("Worm compost")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor031"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass37#_idTextAnchor194"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass37#_idTextAnchor194"
    }
  }, [_vm._v("Chapter 6—Electronics")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor032"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass38#_idTextAnchor196"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass38#_idTextAnchor196"
    }
  }, [_vm._v("E-Waste and Disposal")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor033"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass38#_idTextAnchor198"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass38#_idTextAnchor198"
    }
  }, [_vm._v("Pre-Loved Gadgets")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor034"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass38#_idTextAnchor200"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass38#_idTextAnchor200"
    }
  }, [_vm._v("Planned Obsolescence and Repairs")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor035"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass39#_idTextAnchor202"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass39#_idTextAnchor202"
    }
  }, [_vm._v("Data Storage and Streaming")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor036"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass39#_idTextAnchor204"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass39#_idTextAnchor204"
    }
  }, [_vm._v("Greener habits online")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor037"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass40#_idTextAnchor206"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass40#_idTextAnchor206"
    }
  }, [_vm._v("Chapter 7—Clothing")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor038"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass40#_idTextAnchor208"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass40#_idTextAnchor208"
    }
  }, [_vm._v("What Is Fast Fashion?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor039"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass42#_idTextAnchor210"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass42#_idTextAnchor210"
    }
  }, [_vm._v("How to Spot the Sustainable Brands")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor040"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass42#_idTextAnchor212"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass42#_idTextAnchor212"
    }
  }, [_vm._v("1. Do they have actual certificates to back up "), _c('br'), _vm._v("their claims?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor041"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass42#_idTextAnchor214"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass42#_idTextAnchor214"
    }
  }, [_vm._v("2. Is the supply chain transparent?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor042"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass42#_idTextAnchor216"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass42#_idTextAnchor216"
    }
  }, [_vm._v("3. Is there consistency between the price and "), _c('br'), _vm._v("the product?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor043"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass42#_idTextAnchor218"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass42#_idTextAnchor218"
    }
  }, [_vm._v("4. Can you get in touch with the brand?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor044"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass42#_idTextAnchor220"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass42#_idTextAnchor220"
    }
  }, [_vm._v("Kicking the Habit of Fast Fashion")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor045"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass42#_idTextAnchor222"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass42#_idTextAnchor222"
    }
  }, [_vm._v("Secondhand and Clothing Swaps")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor046"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass44#_idTextAnchor224"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass44#_idTextAnchor224"
    }
  }, [_vm._v("Gittemarie’s guide to thrift shops")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor047"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass44#_idTextAnchor226"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass44#_idTextAnchor226"
    }
  }, [_vm._v("Clothing swaps and secondhand apps")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor048"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass44#_idTextAnchor228"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass44#_idTextAnchor228"
    }
  }, [_vm._v("Repairs and Maintenance")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor049"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass44#_idTextAnchor230"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass44#_idTextAnchor230"
    }
  }, [_vm._v("Tips for the Minimalist Wardrobe")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor050"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass44#_idTextAnchor232"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass44#_idTextAnchor232"
    }
  }, [_vm._v("Fashion Mentality and Designer Labels")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor051"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass44#_idTextAnchor234"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass44#_idTextAnchor234"
    }
  }, [_vm._v("Materials and Textiles")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor052"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass44#_idTextAnchor236"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass44#_idTextAnchor236"
    }
  }, [_vm._v("What are the most sustainable materials?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor053"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass47#_idTextAnchor238"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass47#_idTextAnchor238"
    }
  }, [_vm._v("Chapter 8—Food and Grocery Shopping")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor054"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass48#_idTextAnchor240"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass48#_idTextAnchor240"
    }
  }, [_vm._v("Animal Agriculture")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor055"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass48#_idTextAnchor242"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass48#_idTextAnchor242"
    }
  }, [_vm._v("Imported Feed")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor056"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass48#_idTextAnchor244"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass48#_idTextAnchor244"
    }
  }, [_vm._v("Zero-Waste Meat?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor057"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass48#_idTextAnchor246"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass48#_idTextAnchor246"
    }
  }, [_vm._v("What about White Meat and Fish?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor058"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass48#_idTextAnchor248"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass48#_idTextAnchor248"
    }
  }, [_vm._v("Facts about bottom trawling")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor059"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass50#_idTextAnchor250"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass50#_idTextAnchor250"
    }
  }, [_vm._v("What Should We Eat Instead?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor060"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass50#_idTextAnchor252"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass50#_idTextAnchor252"
    }
  }, [_vm._v("Commonly heard statements about animal products "), _c('br'), _vm._v("and some solutions")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor061"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass54#_idTextAnchor254"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass54#_idTextAnchor254"
    }
  }, [_vm._v("Sustainable Lunches")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor062"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass54#_idTextAnchor256"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass54#_idTextAnchor256"
    }
  }, [_vm._v("Wax wrap")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor063"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass54#_idTextAnchor258"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass54#_idTextAnchor258"
    }
  }, [_vm._v("Lunchbox")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor064"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass54#_idTextAnchor260"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass54#_idTextAnchor260"
    }
  }, [_vm._v("Glass jars")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor065"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass54#_idTextAnchor262"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass54#_idTextAnchor262"
    }
  }, [_vm._v("Canvas bags")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor066"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass54#_idTextAnchor264"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass54#_idTextAnchor264"
    }
  }, [_vm._v("Water bottles and canteens")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor067"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass54#_idTextAnchor266"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass54#_idTextAnchor266"
    }
  }, [_vm._v("Cutlery")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor068"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass54#_idTextAnchor268"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass54#_idTextAnchor268"
    }
  }, [_vm._v("Your own box for salads")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor069"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass54#_idTextAnchor270"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass54#_idTextAnchor270"
    }
  }, [_vm._v("Snacks")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor070"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass54#_idTextAnchor272"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass54#_idTextAnchor272"
    }
  }, [_vm._v("Bringing Your Own Container—A Guide to Politeness")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor071"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass56#_idTextAnchor274"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass56#_idTextAnchor274"
    }
  }, [_vm._v("Chapter 9—Kitchen Guide")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor072"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass57#_idTextAnchor276"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass57#_idTextAnchor276"
    }
  }, [_vm._v("Useful and Plastic-Free Ingredients to Have in the Kitchen")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor073"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass57#_idTextAnchor278"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass57#_idTextAnchor278"
    }
  }, [_vm._v("Seasonal Greens")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor074"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass59#_idTextAnchor280"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass59#_idTextAnchor280"
    }
  }, [_vm._v("Food Storage")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor075"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass59#_idTextAnchor282"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass59#_idTextAnchor282"
    }
  }, [_vm._v("In and out of the fridge")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor076"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass59#_idTextAnchor284"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass59#_idTextAnchor284"
    }
  }, [_vm._v("The freezer")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor077"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass61#_idTextAnchor286"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass61#_idTextAnchor286"
    }
  }, [_vm._v("Food Waste")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor078"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass61#_idTextAnchor288"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass61#_idTextAnchor288"
    }
  }, [_vm._v("How to Buy Groceries without Any Trash")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor079"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor290"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor290"
    }
  }, [_vm._v("Conventional Supermarkets")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor080"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor292"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor292"
    }
  }, [_vm._v("My Favorite Recipes")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor081"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor294"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor294"
    }
  }, [_vm._v("Birthday Buns")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor082"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor296"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor296"
    }
  }, [_vm._v("Burger Buns")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor083"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor298"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor298"
    }
  }, [_vm._v("Vegan Meringue")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor084"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor300"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor300"
    }
  }, [_vm._v("Carrot Cake")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor085"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor302"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor302"
    }
  }, [_vm._v("Homemade Oat Milk")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor086"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor304"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor304"
    }
  }, [_vm._v("Green Ravioli with Nut Filling")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor087"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor306"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor306"
    }
  }, [_vm._v("Plant-Based Pasta Carbonara")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor088"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor308"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor308"
    }
  }, [_vm._v("Mac ’n’ Tease")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor089"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor310"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor310"
    }
  }, [_vm._v("Pasta Salad with Curry Dressing")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor090"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor312"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor312"
    }
  }, [_vm._v("Beet Wellington")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor091"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor314"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass63#_idTextAnchor314"
    }
  }, [_vm._v("Problems with Popular Plants")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor092"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass64#_idTextAnchor316"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass64#_idTextAnchor316"
    }
  }, [_vm._v("Chapter 10—Zero Waste on the Go")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor093"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass65#_idTextAnchor318"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass65#_idTextAnchor318"
    }
  }, [_vm._v("Make Your Own Zero-Waste Kit")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor094"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass65#_idTextAnchor320"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass65#_idTextAnchor320"
    }
  }, [_vm._v("Sustainable Vacations")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor095"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass65#_idTextAnchor322"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass65#_idTextAnchor322"
    }
  }, [_vm._v("Great vacations without planes")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor096"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass65#_idTextAnchor324"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass65#_idTextAnchor324"
    }
  }, [_vm._v("Buying green while on vacation")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor097"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass67#_idTextAnchor326"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass67#_idTextAnchor326"
    }
  }, [_vm._v("Chapter 11—Waste Free for Parties and Holidays")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor098"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass67#_idTextAnchor328"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass67#_idTextAnchor328"
    }
  }, [_vm._v("Gifts")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor099"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass67#_idTextAnchor330"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass67#_idTextAnchor330"
    }
  }, [_vm._v("The homemade")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor100"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass67#_idTextAnchor332"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass67#_idTextAnchor332"
    }
  }, [_vm._v("The pre-loved")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor101"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass68#_idTextAnchor334"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass68#_idTextAnchor334"
    }
  }, [_vm._v("The experience")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor102"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass68#_idTextAnchor336"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass68#_idTextAnchor336"
    }
  }, [_vm._v("Gift Wrapping")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor103"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass68#_idTextAnchor338"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass68#_idTextAnchor338"
    }
  }, [_vm._v("Do like Grandma")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor104"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass68#_idTextAnchor340"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass68#_idTextAnchor340"
    }
  }, [_vm._v("Refuse gift wrapping")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor105"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass68#_idTextAnchor342"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass68#_idTextAnchor342"
    }
  }, [_vm._v("Use what you already have")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor106"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass69#_idTextAnchor344"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass69#_idTextAnchor344"
    }
  }, [_vm._v("Chapter 12—Plastic-Free Care Products")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor107"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass70#_idTextAnchor347"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass70#_idTextAnchor347"
    }
  }, [_vm._v("Oral Hygiene")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor108"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass70#_idTextAnchor349"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass70#_idTextAnchor349"
    }
  }, [_vm._v("Shaving")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor109"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass70#_idTextAnchor351"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass70#_idTextAnchor351"
    }
  }, [_vm._v("Soap Guide")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor110"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass71#_idTextAnchor353"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass71#_idTextAnchor353"
    }
  }, [_vm._v("A solid soap tip")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor111"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass71#_idTextAnchor355"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass71#_idTextAnchor355"
    }
  }, [_vm._v("Periods")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor112"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass71#_idTextAnchor357"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass71#_idTextAnchor357"
    }
  }, [_vm._v("DIY Makeup and Beauty Tips")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor113"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass72#_idTextAnchor359"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass72#_idTextAnchor359"
    }
  }, [_vm._v("Homemade Body Lotion")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor114"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass73#_idTextAnchor361"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass73#_idTextAnchor361"
    }
  }, [_vm._v("Homemade Setting Powder")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor115"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass73#_idTextAnchor363"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass73#_idTextAnchor363"
    }
  }, [_vm._v("Homemade Concealer")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor116"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass73#_idTextAnchor365"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass73#_idTextAnchor365"
    }
  }, [_vm._v("Homemade Blush")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor117"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass73#_idTextAnchor367"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass73#_idTextAnchor367"
    }
  }, [_vm._v("Homemade Lip Tint")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor118"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass74#_idTextAnchor369"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass74#_idTextAnchor369"
    }
  }, [_vm._v("Homemade Eyebrow Tint/Eye Shadow")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor119"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass74#_idTextAnchor371"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass74#_idTextAnchor371"
    }
  }, [_vm._v("Homemade Mascara")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor120"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass74#_idTextAnchor373"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass74#_idTextAnchor373"
    }
  }, [_vm._v("Easy Facemask")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor121"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass74#_idTextAnchor375"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass74#_idTextAnchor375"
    }
  }, [_vm._v("Charcoal Mask")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor122"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass75#_idTextAnchor377"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass75#_idTextAnchor377"
    }
  }, [_vm._v("Products That You Might Want to Phase Out or "), _c('br'), _vm._v("Stop Buying Right Away")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor123"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass77#_idTextAnchor380"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass77#_idTextAnchor380"
    }
  }, [_vm._v("Chapter 13—I Am Super Green—Now What?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor124"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass79#_idTextAnchor382"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass79#_idTextAnchor382"
    }
  }, [_vm._v("Chapter 14—Guilt Does Not Plant Trees")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor125"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass82#_idTextAnchor387"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass82#_idTextAnchor387"
    }
  }, [_vm._v("Works Cited and Sources")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor126"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass83#_idTextAnchor389"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass83#_idTextAnchor389"
    }
  }, [_vm._v("Special Thanks")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor127"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/SustainableBadass5#_idTextAnchor130"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/SustainableBadass5#_idTextAnchor130"
    }
  }, [_vm._v("About the Author")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor128"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-037aa9ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SustainableBadass-4.vue
// module id = 72
// module chunks = 0